(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["choerodon-ui-demo-data-mock.min"] = factory();
	else
		root["choerodon-ui-demo-data-mock.min"] = factory();
})(window, function() {
return 